<template>
  <div style="position: relative; padding: 0px 0 30px">
    <v-premium-plan-popup
      :showAll="false"
      marginTop="65"
      v-if="$store.getters.getPackage != 'premium'"
      style="border-radius: 5px;"
      text="Upgrade to Premium, starting at 500 baht / month to view sales summary and best seller products for the further analysis. Upgrade now"
    ></v-premium-plan-popup>
    <v-container fluid>
      <v-layout class="mb-2">
        <v-flex class="text-xs-right">
          <v-btn
            outline
            color="grey"
            v-if="$store.getters.getPackage != 'premium'"
            :loading="loading"
          >
            <i class="fas fa-file-export mr-1"></i> {{ $t('export') }}
            <v-premium-lock></v-premium-lock
          ></v-btn>
          <v-btn
            v-else-if="$store.getters.getPackage == 'premium'"
            @click="exportData"
            color="primary"
            outline
            class="ma-0 mb-1"
            :loading="loading"
          >
            <i class="fas fa-file-export mr-1"></i>
            {{ $t('export') }}
          </v-btn>
        </v-flex>
      </v-layout>
      <date-filter
        v-model="selectedDate"
        :showTime="true"
        @onSelected="getDashboardShopAnalytic"
      ></date-filter>
      <div class="my-3">
        <v-layout row wrap>
          <v-flex xs12 lg3 class="pl-1">
            <v-card height="100%" class="pa-0">
              <v-card-text class="pb-1 statscard">
                <p class="mb-0">{{ $t('Total Orders') }}</p>
                <h2 class="text-xs-right mr-2">{{ totalorder | numberFormat }}</h2>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex xs12 lg9>
            <v-layout row wrap class="mb-0">
              <v-flex xs12 lg3 class="pl-1">
                <v-card height="100%" class="pa-0">
                  <v-card-text class="pb-1 statscard">
                    <p class="mb-0">{{ $t('Total Sales') }} ({{ $t('Baht') }})</p>
                    <h2 class="text-xs-right mr-2">{{ totalamount | numberFormat }}</h2>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs12 lg3 class="pl-1">
                <v-card height="100%" class="pa-0">
                  <v-card-text class="pb-1 statscard">
                    <p class="mb-0">{{ $t('Total Sales (without Shipping Charge)') }} ({{ $t('Baht') }})</p>
                    <h2 class="text-xs-right mr-2">
                      {{ (totalamount - totalshippingcharge) | numberFormat }}
                    </h2>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs12 lg3 class="pl-1">
                <v-card height="100%" class="pa-0">
                  <v-card-text class="pb-1 statscard">
                    <p class="mb-0">{{ $t('Total Shipping Charge') }} ({{ $t('Baht') }})</p>
                    <h2 class="text-xs-right mr-2">
                      {{ totalshippingcharge | numberFormat }}
                    </h2>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs12 lg3 class="pt-1 pl-1" v-if="enableProductCost">
                <v-card height="100%">
                  <v-card-text class="pb-1 statscard">
                    <p class="mb-0">{{ $t('product_cost') }} ({{ $t('Baht') }})</p>
                    <h2 class="text-xs-right mr-2 mt-0 mb-1">
                      {{ totalcost | numberFormat }}
                    </h2>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs12 lg3 class="pt-1 pl-1">
                <v-card height="100%">
                  <v-card-text class="pb-1 statscard">
                    <p class="mb-0">{{ $t('Avg Sales / 1 Order') }} ({{ $t('Baht') }})</p>
                    <h2 class="text-xs-right mr-2 mt-0 mb-1">
                      {{ (totalamount / totalorder) | numberFormat }}
                    </h2>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs12 lg3 class="pt-1 pl-1">
                <v-card height="100%">
                  <v-card-text class="pb-1 statscard">
                    <p class="mb-0">{{ $t('Avg Sales (without Shipping Charge) / 1 Order') }} ({{ $t('Baht') }})</p>
                    <h2 class="text-xs-right mr-2 mt-0 mb-1">
                      {{ ((totalamount - totalshippingcharge) / totalorder) | numberFormat }}
                    </h2>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs12 lg3 class="pt-1 pl-1">
                <v-card height="100%">
                  <v-card-text class="pb-1 statscard">
                    <p class="mb-0">{{ $t('Avg Shipping Charge / 1 Order') }} ({{ $t('Baht') }})</p>
                    <h2 class="text-xs-right mr-2 mt-0 mb-1">
                      {{ (totalshippingcharge / totalorder) | numberFormat }}
                    </h2>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs12 lg3 class="pt-1 pl-1" v-if="enableProductCost">
                <v-card height="100%">
                  <v-card-text class="pb-1 statscard">
                    <p class="mb-0">{{ $t('Profit') }} ({{ $t('Baht') }})</p>
                    <h2 class="text-xs-right mr-2 mt-0 mb-1">
                      {{ (totalamount - totalcost) | numberFormat }}
                    </h2>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </div>
      <h2>{{ $t('Best seller') }}</h2>
      <v-data-table
        expand
        :loading="loading"
        v-bind:pagination.sync="pagination"
        :headers="headers"
        :items="products"
        item-key="productid"
        class="elevation-1 scgallrenttable"
        style="margin-bottom: 70px;"
      >
        <template slot="items" slot-scope="props">
          <tr @click="clickToggleTable(props)">
            <td class="text-xs-center" style="position: relative">
              {{ (pagination.page - 1) * pagination.rowsPerPage + props.index + 1 }}
              <img
                src="/static/img/assets/shop/crown1.png"
                v-if="(pagination.page - 1) * pagination.rowsPerPage + props.index == 0"
                style="width: 25px; position: absolute; margin-left: -12px; left: 50%; top: -10px"
              />
              <img
                src="/static/img/assets/shop/crown2.png"
                v-if="(pagination.page - 1) * pagination.rowsPerPage + props.index == 1"
                style="width: 25px; position: absolute; margin-left: -12px; left: 50%; top: -10px"
              />
              <img
                src="/static/img/assets/shop/crown3.png"
                v-if="(pagination.page - 1) * pagination.rowsPerPage + props.index == 2"
                style="width: 25px; position: absolute; margin-left: -12px; left: 50%; top: -10px"
              />
            </td>
            <td class="text-xs-left" style="width: 310px;">
              {{ props.item.productname ? props.item.productname : $t('All Deleted Products') }}
            </td>
            <td class="text-xs-center" v-if="enableProductCost">{{ props.item.totalorders | numberFormat }}</td>
            <td class="text-xs-center">{{ props.item.totalquantity | numberFormat }}</td>
            <td class="text-xs-center" v-if="enableProductCost">{{ props.item.totalcost | numberFormat }}</td>
            <td class="text-xs-center" v-if="enableProductCost">{{ (props.item.totalamount - props.item.totalcost) | numberFormat }}</td>
            <td class="text-xs-center">
              {{ props.item.totalamount | numberFormat }}
            </td>
          </tr>
        </template>
        <template slot="expand" slot-scope="props">
          <tr
            v-for="(option, i) in props.item.options"
            :key="`option${props.index + i}`"
            style="display: block; color: gray"
          >
            <td class="text-xs-center" style="position: relative; width: 160px;"></td>
            <td class="text-xs-left" style="width: 24vw;">
              {{ props.item.productname ? props.item.productname : $t('All Deleted Products') }}
              {{ option.name }}
            </td>
            <td class="text-xs-center" style="width: 230px;">
              {{ option.quantity | numberFormat }}
            </td>
            <td class="text-xs-center" style="width: 230px;" v-if="enableProductCost">
              {{ option.cost | numberFormat }}
            </td>
            <td class="text-xs-center" style="width: 230px;" v-if="enableProductCost">
              {{ (option.amount - option.cost) | numberFormat }}
            </td>
            <td class="text-xs-center" style="width: 230px;">
              {{ option.amount | numberFormat }}
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-container>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import dayjs from 'dayjs'
import DateFilter from '@/components/view/analytics/DateFilter'
import XLSX from 'xlsx'
import numeral from 'numeral'

export default {
  components: {
    DateFilter
  },
  data() {
    return {
      toggleTable: [],
      loading: true,
      totalamount: '',
      totalcost: '',
      totalshippingcharge: '',
      totalorder: '',
      selectedDate: {
        start: dayjs()
          .subtract(7, 'days')
          .format('YYYY-MM-DD 00:00'),
        end: dayjs().format('YYYY-MM-DD 23:59')
      },
      pagination: { sortBy: 'none', descending: true, rowsPerPage: 25 },
      headers: [
        {
          text: 'No.',
          // width: '1%',
          align: 'left',
          sortable: false
        },
        {
          text: this.$t('Product Name'),
          value: 'productname',
          align: 'left'
        },
        {
          text: this.$t('Quantity'),
          value: 'totalquantity',
          align: 'center'
          // width: '1%'
        },
        {
          text: this.$t('Sales'),
          value: 'totalamount',
          align: 'center'
          // width: '2%'
        }
      ],
      products: [],
      enableProductCost: false
    }
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  mounted() {
    this.enableProductCost = this.allowBetaFeature('product_cost')
    this.getDashboardShopAnalytic()
    this.adjustTableHeaders()
  },
  methods: {
    clickToggleTable(props) {
      this.$nextTick(() => {
        props.expanded = !props.expanded
      })
    },
    getDashboardShopAnalytic(date) {
      this.loading = true
      if (date) {
        var data = {
          pageid: this.selectedBot.pageid,
          datefrom: date.start,
          dateto: date.end
        }
      } else {
        var data = {
          pageid: this.selectedBot.pageid,
          datefrom: this.selectedDate.start,
          dateto: this.selectedDate.end
        }
      }

      api.getdashbroadshopanalytic(data, (error, response) => {
        this.loading = false
        if (response && response.responsecode == 200 && response.data) {
          this.products = response.data2
          this.totalamount = response.data.totalamount
          this.totalcost = response.data.totalcost
          this.totalshippingcharge = response.data.totalshippingcharge
          this.totalorder = response.data.totalorder
        } else {
          this.products = []
          this.totalamount = 0
          this.totalcost = 0
          this.totalshippingcharge = 0
          this.totalorder = 0
        }
      })
    },
    exportData() {
      let vm = this
      let csvContent = ''
      if (vm.loading) {
        return false
      }
      let json = []
      json.push([
        `${this.$t('from')} ` +
          dayjs(vm.selectedDate.start).format('DD/MM/YYYY') +
          ` ${this.$t('to')} ` +
          dayjs(vm.selectedDate.end).format('DD/MM/YYYY')
      ])

      json.push([])
      json.push([this.$t('Sales Report')])

      json.push([this.$t('Total Orders'), numeral(this.totalorder).format('0,0')])
      json.push([this.$t('Total Sales'), numeral(this.totalamount).format('0,0')])
      json.push([
        this.$t('Total Sales (without Shipping Charge)'),
        numeral(this.totalamount - this.totalshippingcharge).format('0,0')
      ])
      json.push([this.$t('Total Shipping Charge'), numeral(this.totalshippingcharge).format('0,0')])
      json.push([
        this.$t('Avg Sales / 1 Order'),
        numeral(this.totalamount / this.totalorder).format('0,0')
      ])
      json.push([
        this.$t('Avg Sales (without Shipping Charge) / 1 Order'),
        numeral((this.totalamount - this.totalshippingcharge) / this.totalorder).format('0,0')
      ])
      json.push([
        this.$t('Avg Shipping Charge / 1 Order'),
        numeral(this.totalshippingcharge / this.totalorder).format('0,0')
      ])

      const wb = XLSX.utils.book_new()
      wb.Props = {
        Title: 'Zwiz Sales Report',
        Subject: 'Sales Report',
        Author: 'Zwiz',
        CreatedDate: dayjs()
      }
      wb.SheetNames.push('Overall')
      const ws = XLSX.utils.aoa_to_sheet(json)
      wb.Sheets['Overall'] = ws
      wb.SheetNames.push('Products')
      var header = [this.$t('Product Name'), this.$t('Quantity'), this.$t('Sales')]
      var products = []
      this.products.map(el => {
        el.options.map(item => {
          products.push([
            el.productname ? el.productname + ' ' + item.name : this.$t('All Deleted Products'),
            numeral(item.quantity).format('0,0'),
            numeral(item.amount).format('0,0')
          ])
        })
      })
      products.unshift(header)
      const ws2 = XLSX.utils.aoa_to_sheet(products)
      wb.Sheets['Products'] = ws2

      XLSX.writeFile(wb, 'zwiz-salesreport.xlsx')
    },
    adjustTableHeaders() {
      if (this.enableProductCost) {
        this.headers.splice(2, 0, {
          text: this.$t('total_orders'),
          value: 'totalorders',
          align: 'center'
        })
        this.headers.splice(4, 0, {
          text: this.$t('product_cost'),
          value: 'totalcost',
          align: 'center'
        },
        {
          text: this.$t('Profit'),
          value: 'totalprofit',
          align: 'center'
        })
      }
    }
  }
}
</script>

<style lang="scss">
/* .scgallrenttable .v-table__overflow .v-datatable.v-table.theme--light thead tr th {
  padding: 0 !important;
  text-align: center;
} */
.statscard {
  display: flex;
  justify-content: space-between;
  height: 100%;
  flex-direction: column;
}

.table2 thead {
  display: none;
}
.table2 .v-datatable__actions {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/ProductAnalytics.vue